import React, { Component } from 'react';

class Education extends Component {
  render() {

    if(this.props.data){
      //var skillmessage = this.props.data.skillmessage;
      var education = this.props.data.education.map(function(education){
        return <div key={education.school+education.graduated}>
          <div className="row">
            <div className="two columns max-30 header-col">
              <img src={"images/education/"+education.image} alt={education.school} />
            </div>
            <div className="ten columns main-col">
              <h3>{education.school}</h3>
              <p className="info">{education.degree}<br/>
              <em className="date">{education.graduated}</em></p>
              <p>{education.description}</p>
            </div>
          </div>
            
          </div>
      })
    }

    return (
      <section id="education">

      <div className="row education">
         <div className="three columns header-col">
            <h1><span>Education</span></h1>
         </div>

         <div className="nine columns main-col">
            <div className="row item">
               <div className="twelve columns">
                 {education}
               </div>
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default Education;



// WEBPACK FOOTER //
// ./src/Components/Education.js